<div class="example-wrap">
  <div [formGroup]="formGroup" class="k-form k-form-horizontal" id="advancedFilter">
    @for (field of formFields; track field.field_name) {
      <div class="formBlock" [ngStyle]="{'width': field.width, 'margin-left': field.marginLeft, 'margin-right': field.marginRight}">
        @switch (field.field_data_type) {
          @case ('TEXT') {
            <app-input-text-box class="col-12 col-md-6 col-lg-4 px-0" [field]="field"
              [formGroup]="formGroup" (formGroupValue)="updatedFormGroupVal($event)" [isUpdateFields]="isUpdateFields">
            </app-input-text-box>
          }
          @case ('DATE') {
            <app-input-date-picker [field]="field" Class="col-12 col-md-6 col-lg-4 px-2"
              [formGroup]="formGroup" (formGroupValue)="updatedFormGroupVal($event)" [isUpdateFields]="isUpdateFields">
            </app-input-date-picker>
          }
          @case ('TEXTAREA') {
            <app-input-text-area class="col-12 col-md-6 col-lg-4 px-0" [field]="field"
              [formGroup]="formGroup" (formGroupValue)="updatedFormGroupVal($event)" [isUpdateFields]="isUpdateFields">
            </app-input-text-area>
          }
          @case ('DROPDOWN') {
            <app-input-drop-down class="col-12 col-md-6 col-lg-4 px-0" [field]="field"
              [formGroup]="formGroup" (formGroupValue)="updatedFormGroupVal($event)" [isUpdateFields]="isUpdateFields">
            </app-input-drop-down>
          }
          @case ('MULTISELECT') {
            <app-input-multi-select class="col-12 col-md-6 col-lg-4 px-0" [field]="field"
              [formGroup]="formGroup" (formGroupValue)="updatedFormGroupVal($event)" [isUpdateFields]="isUpdateFields">
            </app-input-multi-select>
          }
          @case ('AUTOCOMPLETE') {
            <app-input-auto-complete class="col-12 col-md-6 col-lg-4 px-0" [field]="field"
              [formGroup]="formGroup" (formGroupValue)="updatedFormGroupVal($event)" [isUpdateFields]="isUpdateFields">
            </app-input-auto-complete>
          }
          @case ('NUMBER') {
            <app-input-numeric-textbox class="col-12 col-md-6 col-lg-4 px-0" [field]="field"
              [formGroup]="formGroup" (formGroupValue)="updatedFormGroupVal($event)" [isUpdateFields]="isUpdateFields">
            </app-input-numeric-textbox>
          }
          @case ('CHECKBOX') {
            <app-input-check-box class="col-12 col-md-6 col-lg-4 px-0" [field]="field"
              [formGroup]="formGroup" (formGroupValue)="updatedFormGroupVal($event)" [isUpdateFields]="isUpdateFields">
            </app-input-check-box>
          }
          @case ('RADIO') {
            <app-input-radio-button class="col-12 col-md-6 col-lg-4 px-0" [field]="field"
              [formGroup]="formGroup" (formGroupValue)="updatedFormGroupVal($event)" [isUpdateFields]="isUpdateFields">
            </app-input-radio-button>
          }
        }
        <!-- @if (isSubmit && formGroup.controls[field.field_name].errors && formGroup.controls[field.field_name].errors['required']) {
            <kendo-formerror>Error:{{field.field_name}} is required</kendo-formerror>
        } -->
      </div>
    }
  </div>
</div>
